<template>
  <div>
    <rabbey-table-3
      :data="reportData"
      :columns="reportColumns"
      :actions="reportActions"
      :loading="reportDataLoading"
    />
  </div>
</template>

<script>
import { columns } from "@/columns/RequestReportByProductByMonth/RequestReportByProductByMonthColumns";

const actualYear = new Date().getFullYear();

export default {
  name: "ReportByProductByMonthTable",
  props: {
    yearSelected: {
      type: Number,
      default: actualYear
    }
  },
  data() {
    return {
      reportData: [],
      reportColumns: columns(this),
      reportActions: [],
      reportDataLoading: false
      // ActualYear: actualYear
    };
  },
  mounted() {
    this.GetReportData();
  },
  // computed: {
  //   GetYear() {
  //     return this.yearSelected
  //   }
  // },
  methods: {
    async GetReportData() {
      this.reportDataLoading = true;
      await this.$http
        .get("api/serviceRequests/Get_External_Request_Report_By_Producsts", {
          params: {
            year: this.yearSelected
          }
        })
        .then((response) => {
          console.log("Response: ", response);
          this.reportData = response.data;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.reportDataLoading = false;
        });
    }
  },
  watch: {
    async yearSelected(oldV, newV) {
      console.log("yearSelected: ", newV);
      await this.GetReportData();
    }
  }
};
</script>

<style lang="scss" scoped></style>
